import React, { useEffect, useState } from "react";
import Axios from '../../utils/api/axiosConf';
import { url } from '../../utils/api/api';
import { RedNotif, GreenNotif, FarsiDate } from "../../utils/utils";
import TABLE from "../../components/table/table";
import RADIO from "../../components/radio/radio";
import { color } from "../../utils/themes/color";
import './index.css'




export default function Requests() {

    const [data, setData] = useState();
    const [page, setPage] = useState({ current: 1, total: 1, pageSize: 5 });
    const [loading, setLoading] = useState(null);
    const [filter, setFilter] = useState("all");



    const filters = [{ "name": "همه", "value": "all" }, { "name": "برنامه های غذایی", "value": "food" }, { "name": "برنامه های ورزشی", "value": "exercise" }];

    const columns = [

        {
            title: 'تاریخ ثبت',
            dataIndex: 'program',
            render: (e) => <p>{FarsiDate(e.programId.insertDate)}</p>,
            key: '_id',
        },
        {
            title: 'نام برنامه',
            dataIndex: 'program',
            render: (e) => <p>{e.programId.title}</p>,
            key: '_id',
        },
        {
            title: 'توضیحات',
            dataIndex: 'description',
            key: '_id',
        },
        {
            title: 'نام مربی',
            dataIndex: 'coach',
            render: (e) => <p>{e.fullName}</p>,
            key: '_id',
        },
        {
            title: 'نام ورزشکار',
            dataIndex: 'user',
            render: (e) => <p>{e.fullName}</p>,
            key: '_id',
        },
        {
            title: 'نوع برنامه',
            dataIndex: 'typeRequest',
            render: (e) => <p>{type(e)}</p>,
            key: '_id',
        },
        {
            title: 'وضعیت',
            dataIndex: 'status',
            render: (e) => <p>{status(e)}</p>,
            key: '_id',
        },
    ];


    const type = (t) => {
        switch (t) {
            case "food": return "برنامه غذایی"
            case "exercise": return "برنامه ورزشی"
        }
    }

    const status = (s) => {
        switch (s) {
            case "pending": return "درحال بررسی"
            case "accepted": return "پذیرفته شده"
            case "rejected": return "پذیرفته نشده"
            case "edited": return "ویرایش شده"
            case "completed": return "تکمیل شده"
        }
    }

    useEffect(() => {
        setLoading(true)
        if (filter == "all") {
            Axios.get(`${url}request/request-search?limit=5&pageNumber=${page.current}`)
                .then((response) => {
                    if (response.status === 200 || response.status === 201) {
                        setData(response.data.docs)
                        setPage({
                            ...page,
                            current: response.data.page,
                            total: response.data.totalDocs

                        })
                        setLoading(false)
                    }
                    else {
                        RedNotif(response.message)
                    }
                })
                .catch((error) => {
                    RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
                });
        } else {
            Axios.get(`${url}request/request-search?limit=5&pageNumber=${page.current}&typeRequest=${filter}`)
                .then((response) => {
                    if (response.status === 200 || response.status === 201) {
                        setData(response.data.docs)
                        setPage({
                            ...page,
                            current: response.data.page,
                            total: response.data.totalDocs

                        })
                        setLoading(false)
                    }
                    else {
                        RedNotif(response.message)
                    }
                })
                .catch((error) => {
                    RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
                });
        }
    }, [page.current, filter])



 


    const pager = (p) => {
        if (p != undefined) {
            setPage({ ...page, current: p })
        }
        return page;
    }

    return (
        <>
            <div className="filterUser" style={{ background: color.primary }}>
                <p style={{ float: 'right', color: color.textColor }} >همه درخواست ها</p>
                <div style={{ float: "left" }}>
                    <RADIO click={(e) => { setFilter(e); setPage({ ...page, current: 1 }) }} items={filters} defaultValue={"all"} />
                </div>
            </div>
            <TABLE
                data={data}
                columns={columns}
                page={pager}
                loading={loading} />
        </>
    )








}